
export function withRef(ref, component) {
  return new Proxy({}, {
    get(target, prop) { return prop == 'ref' ? ref : component[prop]; }
  });
}
